"use client"

import PropTypes from 'prop-types';
import classNames from "classnames";
import {markdownToHtml} from "../markdown/markdownToHtml";

import styles from './styles/Markdown.module.scss';
import {useMemo} from "react";
import {markdownDefaultMaxLength} from "../editors/utils";
import {useStores} from "../../stores/useStores";

export default function Markdown({withStyles = false, source, allowLinks = true, ...restProps}) {
    const {interfaceStore} = useStores();
    const markdownClassname = classNames({
        [styles.markdown]: withStyles === true,
    });

    const contents = useMemo(() => {
        let c = source || "";
        if (!allowLinks) {
            c = c?.replace(/\[.*\]\(.*\)/g, "") || "";
        }

        if (c.length > markdownDefaultMaxLength) {
            c = c.slice(0, markdownDefaultMaxLength);
        }

        return markdownToHtml(c, {currentFullUrl: interfaceStore.currentFullUrl, allowGfmLinks: allowLinks});
    }, [source])

    return <div className={markdownClassname} {...restProps} dangerouslySetInnerHTML={{__html: contents}} />
}

Markdown.propTypes = {
    withStyles: PropTypes.bool,
    source: PropTypes.string,
    allowLinks: PropTypes.bool,
};

